import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bzqgcv5hnl: FaireBrandEntity = {
  token: "b_bzqgcv5hnl",
  type: "brand",
  name: "Dandarah (Ships from Canada)",
  avatarUrl:
    "https://cdn.faire.com/fastly/c608f97d24bc73a8251cda254d3bc57221f129a4399b3b9b3c224998da0198d3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8a7c9d5e63f3ca3087efec5587dcc56c8798649078e38ebbd4072dd2b36b8f32.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c608f97d24bc73a8251cda254d3bc57221f129a4399b3b9b3c224998da0198d3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8a7c9d5e63f3ca3087efec5587dcc56c8798649078e38ebbd4072dd2b36b8f32.png",
  location: "Montreal, QC, CAN",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 150,
  isTopShop: true,
  isInsider: false,
  description:
    "Celebrating Craftsmanship and Supporting Artisans!\n\nDandarah is a Canadian women-owned social enterprise based in Montreal, with a mission to support artisans and sustain traditional crafts. \nWe partner with artisans in different rural areas and inner cities in Egypt to create high-quality handmade home décor and fashion accessories rooted in local age-old crafts, such as hand weaving and glass blowing. We also partner with artisans in Haiti to create beautiful home décor products from upcycled oil drums metal and riverstone.\n\nAs a Fair Trade Federation verified member, Dandarah is fully committed to fair trade principles in all of its business practices. As a member of 1% for the Planet, Dandarah commits to donate 1% of annual sales to support nonprofit organizations focused on the environment. Dandarah also partners with Doctors Without Borders/Médecins Sans Frontières (MSF) Canada by donating 1% of annual sales to support MSF's humanitarian work. Dandarah is also a proud member of the Museum Store Association (MSA).\n\nEach one of our products is designed to be functional, while preserving the artisans’ traditional techniques. Each piece tells the unique and beautiful story of people, lands and traditions.\n\nWe ship to North America, Europe and Oceania.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:22.159Z",
    importedBy: "entity-db-cli",
  },
};
